import { selectGtoState, useDispatch, gerenciaTecnicaSlice } from "../../../../stateManagement/redux"
import ButtonCircle from "../../../../shared/components/button_circle"
import ButtonBig from "../../../../shared/components/button_big"
import { useSelector } from 'react-redux';
import { useEffect, useRef, useState, useCallback, useMemo, useDeferredValue, startTransition } from 'react';
import { createPortal } from 'react-dom';
import ReportCard from "../../reports_viewer/cart_with_info/card";
import generatePDF, { Options } from 'react-to-pdf';
import { validateAndFormatNumber } from "../../../../stateManagement/redux/slices/gerencia_tecnica/auxiliarFunctions";
import { validationTypeEnum } from "../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces";
import { validateAndConvertFraction } from "../../../../shared/util/validateFunction";
import { projectList } from "../../../../shared/util/projectList";
import { UploadActivitiesModal } from "./uploadActivityModal";
import { delay } from "./fileRow";
import { StatesTabs } from "./statesTabs";
import { GeneralTab } from "./generalTab";
import { ActivitiesList } from "./activitiesList";
import { CartsList } from "./cartsList";
import { ButtonsTab, collectBlockingErrors } from "./buttonsTab";
import { ErrorList } from "./errorList";
import { uploadConsolidatedActivities } from "../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { set } from "react-datepicker/dist/date_utils";
import { compareStringsAccentInsensitive } from "../../../../shared/util/compare";
import { checkErrors } from "./checkErros";
import { getGroupAssignedConfig } from "src/shared/util/requestDataServer";
import { TamConsolidateTab, type TamConsolidateReadyPayload } from "./TamConsolidateTab";
import { uploadDynSupportFile } from "../tam/tamViewerService";
import type { FileCustom } from "../interfaces";
import type { ActivityWellHint } from "../tam/lib/tamLocationMatch";
import { Box } from "@mui/material";

export const UploadModal = ({ close, originalFlow, tamFiles = [] }: { close: any, originalFlow: string, tamFiles?: FileCustom[] }) => {

    const dispatch = useDispatch();

    const targetRef = useRef<any>();

    const mainState = useSelector(selectGtoState);

    const [showCartModalReport, setshowCartModalReport] = useState(false)

    const [showListOfActivities, setShowListOfActivities] = useState(false)

    const [activeFieldForActivities, setActiveFieldForActivities] = useState('')

    const [executedDate, setExecutedDate] = useState<any>(null);

    const [numeroCuadrilla, setNumeroCuadrilla] = useState<number>();

    const [filterStates, setFilterStates] = useState([
        { id: "summary", name: "Generalidades", amountElement: 0 },
        { id: "activities", name: "Actividades", amountElement: 0 },
        { id: "carts", name: "Cartas", amountElement: 0 },
        { id: "tam", name: "TAM", amountElement: tamFiles.length },
        { id: "errors", name: "Errores", amountElement: 0 },
        { id: "files", name: "Archivos", amountElement: 0 },
    ])

    const [errors, setErrors] = useState<any>({})

    const [sortActivities, setSortActivities] = useState<any[]>([])

    const [tamTabMounted, setTamTabMounted] = useState(false)

    const [actveActivityWithCard, setActveActivityWithCard] = useState<any>([])

    const [ActiveCuadrilla, setActiveCuadrilla] = useState("")

    const [activeState, setActiveState] = useState(filterStates[0].id)

    const [setSizeToGeneratePdf, setsetSizeToGeneratePdf] = useState(false)

    const [reloadCartComponent, setReloadCartComponent] = useState(false)

    const [uploadTaskWithVariables, setUploadTaskWithVariables] = useState(false)

    const [uploadActivitiesStep, setUploadActivitiesStep] = useState('CheckWsMessage')

    const [activitiesToUpload, setActivitiesToUpload] = useState<any[]>([])

    const [uploadBlockingMessages, setUploadBlockingMessages] = useState<string[]>([])

    const [canUploadActivities, setCanUploadActivities] = useState(false)

    const [uploadSessionKey, setUploadSessionKey] = useState(0)

    const [uploadIsValidating, setUploadIsValidating] = useState(false)

    const [groupAssignedConfig, setGroupAssignedConfig] = useState<any>()

    const [groupAssigned, setgroupAssigned] = useState<any>()

    const [tamReady, setTamReady] = useState<TamConsolidateReadyPayload[]>([])

    const handleTamReadyChange = useCallback((ready: TamConsolidateReadyPayload[]) => {
        setTamReady(ready)
    }, [])

    const handleFieldChange = useCallback((value: string) => {
        startTransition(() => setActiveFieldForActivities(value))
    }, [])

    const locationByName = useMemo(() => {
        const map = new Map<string, NonNullable<typeof mainState.locations>[number]>()
        mainState.locations?.forEach((loc) => map.set(loc.name, loc))
        return map
    }, [mainState.locations])

    const activityWellHints = useMemo((): ActivityWellHint[] => {
        if (!activeFieldForActivities || !mainState?.activitiesWithCarts?.length) return [];

        const hints: ActivityWellHint[] = [];
        const seen = new Set<string>();

        mainState.activitiesWithCarts.forEach((a) => {
            const pozo = a?.Pozo?.trim?.();
            if (!pozo) return;

            const formatted = validateAndFormatNumber(pozo, activeFieldForActivities);
            const loc =
                locationByName.get(formatted) ??
                mainState.locations?.find((l) => compareStringsAccentInsensitive(l.name, formatted));

            if (!loc || seen.has(loc.id)) return;
            seen.add(loc.id);
            hints.push({
                pozo,
                locationId: loc.id,
                locationName: loc.name,
            });
        });

        return hints;
    }, [mainState?.activitiesWithCarts, mainState?.locations, activeFieldForActivities, locationByName]);

    const { cuadrillas, activities, carts } = useMemo(() => {
        const nextCuadrillas: any[] = []
        const nextActivities: any[] = []
        const taskValidations = mainState?.taskValidations || []

        mainState?.activitiesWithCarts?.forEach((a) => {
            let keyForSquatMembers = 'Ingenieros'

            if (a?.[keyForSquatMembers] === undefined) {
                const personalNameHomologations = taskValidations.find((v: any) => v.name === "Ingenieros")?.homologation || []
                const newKeyForSquatMembers = personalNameHomologations.find((h: any) => Object.keys(a).includes(h))

                if (newKeyForSquatMembers) {
                    keyForSquatMembers = newKeyForSquatMembers
                }
            }

            try {
                const cuadrilla = nextCuadrillas.find((c) => compareStringsAccentInsensitive(c.member, a?.[keyForSquatMembers]))

                if (cuadrilla) {
                    cuadrilla.activities += 1
                    if (a?.haveCart) {
                        cuadrilla.carts += 1
                    }
                } else {
                    const guestMembers: any[] = []

                    a?.[keyForSquatMembers].split('/').forEach((m: string) => {
                        const userExist = mainState?.users?.find((u) => compareStringsAccentInsensitive(u.name, m))
                        if (!userExist) {
                            guestMembers.push(m.trim())
                        }
                    })

                    nextCuadrillas.push({
                        member: a?.[keyForSquatMembers],
                        activities: 1,
                        carts: a?.haveCart ? 1 : 0,
                        guestMembers,
                    })
                }

                const locationName = validateAndFormatNumber(a?.Pozo, activeFieldForActivities)
                const locationExistInDb = locationByName.get(locationName)

                nextActivities.push({
                    line: a.position,
                    location: `${activeFieldForActivities} ${a?.Pozo}`,
                    members: a?.[keyForSquatMembers],
                    haveCart: a?.haveCart ? 'SI' : 'NO',
                    isNameOk: Boolean(locationExistInDb),
                })
            } catch {
                // skip malformed row
            }
        })

        const nextCarts: any[] = []
        mainState?.cardsWithActivities?.forEach((c) => {
            nextCarts.push({
                locationCart: `${activeFieldForActivities} ${c.location}`,
                LocationActivity: `${c?.Pozo ? `${activeFieldForActivities} ${c?.Pozo}` : ''}`,
                source: c.type,
                haveActivity: c.haveActivity,
            })
        })

        return { cuadrillas: nextCuadrillas, activities: nextActivities, carts: nextCarts }
    }, [
        mainState?.activitiesWithCarts,
        mainState?.cardsWithActivities,
        mainState?.users,
        mainState?.taskValidations,
        activeFieldForActivities,
        locationByName,
    ])

    const deferredFieldForValidation = useDeferredValue(activeFieldForActivities)
    const deferredExecutedDate = useDeferredValue(executedDate)
    const deferredNumeroCuadrilla = useDeferredValue(numeroCuadrilla)
    const deferredGroupAssigned = useDeferredValue(groupAssigned)
    const deferredCuadrillas = useDeferredValue(cuadrillas)

    const handleUploadTam = async (): Promise<{
        ok: number;
        failed: { fileName: string; reason: string }[];
        duplicated: number;
    } | null> => {
        if (!tamReady.length) return null
        const groupPrefix = (groupAssigned ?? '').toString().trim()
        const failed: { fileName: string; reason: string }[] = []
        let ok = 0
        let duplicated = 0
        try {
            await Promise.all(
                tamReady.map(async (item) => {
                    const displayName = groupPrefix ? `${groupPrefix}_${item.file.name}` : item.file.name
                    try {
                        const res = await uploadDynSupportFile({
                            file: item.file,
                            executedAt: item.executedAt,
                            locationIds: item.locationIds,
                            wellNames: item.wellNames,
                            fileName: displayName,
                        })
                        if (res?.status === 'duplicated') {
                            duplicated += 1
                        } else {
                            ok += 1
                        }
                    } catch (err) {
                        failed.push({
                            fileName: item.file.name,
                            reason: err instanceof Error ? err.message : 'Error al subir el TAM',
                        })
                    }
                }),
            )
            return { ok, failed, duplicated }
        } catch {
            return {
                ok,
                failed: [{ fileName: 'TAM', reason: 'Error inesperado al subir TAM' }],
                duplicated,
            }
        }
    }

    const onClickVerActividades = (c: any) => {
        setActiveCuadrilla(c.member)
        setActiveState('activities')
    }

    const onChangeActivitiesField = (fieldName: string, preValue: string, newValue: string) => {

        let newActivities = mainState?.activitiesWithCarts?.map((a) => {
            const element = { ...a }

            if (element[fieldName] === preValue) {
                element[fieldName] = newValue
            }

            return element
        })

        let newCards = mainState?.cardsWithActivities?.map((a) => {
            const element = { ...a }

            if (element[fieldName] === preValue) {
                element[fieldName] = newValue
            }
            return element
        })

        newActivities = newActivities?.map((a) => {
            const element = { ...a }
            const cart = newCards?.find((cart: any) => cart.location === a['Pozo'])
            element.haveCart = cart ? true : false
            return element
        })

        newCards = newCards?.map((a) => {
            const act = newActivities?.find((activity: any) => activity['Pozo'] === a.location)

            let element;

            if (!act) {
                element = {
                    haveActivity: false,
                    haveCart: false,
                    location: a.location,
                    Pozo: a.Pozo,
                    "Pump Card Load": a['Pump Card Load'],
                    "Pump Card Position": a['Pump Card Position'],
                    "Surface Card Load": a['Surface Card Load'],
                    "Surface Card Position": a['Surface Card Position']
                }

            } else {
                element = {
                    ...a,
                    ...act,
                    haveActivity: true,
                    haveCart: true
                }
            }
            return element
        })

        if (newActivities) {
            dispatch(gerenciaTecnicaSlice.actions.setActivitiesWithCarts(newActivities));
        }

        if (newCards) {
            dispatch(gerenciaTecnicaSlice.actions.setCardsWithActivities(newCards));
        }

    }

    const onClose = () => {
        close()
        setErrors([])
        dispatch(gerenciaTecnicaSlice.actions.setUploadingStep(''))
        dispatch(
            gerenciaTecnicaSlice.actions.setTaskValidations([])
        );
    }


    useEffect(() => {
        if (!tamFiles.length) {
            setTamTabMounted(false)
            return
        }
        const frame = requestAnimationFrame(() => {
            startTransition(() => setTamTabMounted(true))
        })
        return () => cancelAnimationFrame(frame)
    }, [tamFiles.length])

    useEffect(() => {
        const frame = requestAnimationFrame(() => {
            startTransition(() => {
                try {
                    checkErrors({
                        mainState,
                        executedDate: deferredExecutedDate,
                        activeFieldForActivities: deferredFieldForValidation,
                        cuadrillas: deferredCuadrillas,
                        setSortActivities,
                        setErrors,
                        setFilterStates,
                        filterStates,
                        originalFlow,
                        numeroCuadrilla: deferredNumeroCuadrilla,
                        groupAssigned: deferredGroupAssigned,
                    })
                } catch (error) {
                    console.error('checkErrors failed', error)
                }
            })
        })
        return () => cancelAnimationFrame(frame)
    }, [
        mainState?.activitiesWithCarts,
        mainState?.cardsWithActivities,
        mainState?.locations,
        mainState?.users,
        mainState?.taskValidations,
        deferredFieldForValidation,
        deferredExecutedDate,
        deferredNumeroCuadrilla,
        deferredGroupAssigned,
        deferredCuadrillas,
        originalFlow,
    ])

    useEffect(() => {
        getGroupAssignedConfig().then((data) => {
            setGroupAssignedConfig(data)
        })
    }, [])

    useEffect(() => {
        setFilterStates((prev) =>
            prev.map((tab) => (tab.id === "tam" ? { ...tab, amountElement: tamFiles.length } : tab)),
        )
    }, [tamFiles.length])

    useEffect(() => {

        let fieldCode = '0'

        if (activeFieldForActivities && activeFieldForActivities !== '') {
            const field = groupAssignedConfig?.field.find((x: any) => x.id === activeFieldForActivities)
            if (field) {
                fieldCode = field.code.toString().padStart(1, '0')
            }
        }

        let activityCode = '0'

        if (originalFlow && originalFlow !== '') {
            const activity = groupAssignedConfig?.activity.find((x: any) => x.id === originalFlow)
            if (activity) {
                activityCode = activity.code.toString().padStart(2, '0')
            }
        }

        let squadCode = numeroCuadrilla ? numeroCuadrilla.toString().padStart(1, '0') : ''

        const groupActivityId = `${fieldCode}${activityCode}${squadCode}`

        if (groupActivityId) {
            setgroupAssigned(groupActivityId)
        }

    }, [groupAssignedConfig, activeFieldForActivities, numeroCuadrilla, originalFlow])


    const onClickViewCartFromActivity = (c: any) => {

        const location = c?.location?.replace(activeFieldForActivities, '').trim()

        const activity = mainState?.activitiesWithCarts?.find((a) => a.Pozo === location)

        setActveActivityWithCard(activity)

        setshowCartModalReport(true)

        setShowListOfActivities(false)
    }

    const onClickViewCartFromCard = (c: any) => {

        setShowListOfActivities(false)

        const location = c?.locationCart?.replace(activeFieldForActivities, '').trim()

        const activity = mainState?.cardsWithActivities?.find((a) => a.location === location)

        setActveActivityWithCard(activity)

        setshowCartModalReport(true)

    }

    const onClickDownnloadPdf = async () => {

        if (showListOfActivities) {
            setShowListOfActivities(false)

            for (const activity of mainState?.cardsWithActivities || []) {
                setActveActivityWithCard(activity)
                setReloadCartComponent(true)
                await delay(500)
                setsetSizeToGeneratePdf(true)
                setReloadCartComponent(false)
                await delay(1000)

                const options: Options = {
                    filename: `${activity?.['Pozo']}.pdf`,
                    method: 'save',
                    page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 22, bottom: 22, left: 22 } },
                    overrides: { pdf: { compress: true } },
                    canvas: { qualityRatio: 0.2 }
                }

                await generatePDF(targetRef, options)

            }
            setsetSizeToGeneratePdf(false)
            setShowListOfActivities(true)

        } else {
            setReloadCartComponent(true)
            await delay(500)
            setsetSizeToGeneratePdf(true)
            setReloadCartComponent(false)
            await delay(1000)

            const options: Options = {
                filename: `${actveActivityWithCard?.['Pozo']}.pdf`,
                method: 'open',
                page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 22, bottom: 0, left: 22 } },
                // page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 10, bottom: 0, left: 10 } },
                overrides: { pdf: { compress: true } },
                canvas: { qualityRatio: 0.2 }
            }

            generatePDF(targetRef, options)
            setsetSizeToGeneratePdf(false)
        }
    }

    useEffect(() => {
        console.log('[UploadModal] uploadTaskWithVariables =', uploadTaskWithVariables);
    }, [uploadTaskWithVariables]);

    useEffect(() => {
        if (!uploadTaskWithVariables || !uploadIsValidating) return;

        console.log('[UploadModal] iniciando validación para carga de actividades…', {
            campo: activeFieldForActivities,
            fecha: executedDate,
            cuadrilla: numeroCuadrilla,
            actividadesExcel: mainState?.activitiesWithCarts?.length ?? 0,
        });

        let validationResult = { errors: {} as Record<string, any[]>, validatedActivities: [] as any[] };

        try {
            validationResult = checkErrors({
                mainState,
                executedDate,
                activeFieldForActivities,
                cuadrillas,
                setSortActivities,
                setErrors,
                setFilterStates,
                filterStates,
                originalFlow,
                numeroCuadrilla,
                groupAssigned,
            });
        } catch (error) {
            console.error('[UploadModal] checkErrors falló:', error);
            validationResult = {
                errors: { General: [{ error: 'No se pudo validar las actividades.', type: 'error' }] },
                validatedActivities: [],
            };
        }

        const blockingMessages = collectBlockingErrors(validationResult.errors);
        const hasBlockingErrors = blockingMessages.length > 0;
        const canUpload = validationResult.validatedActivities.length > 0 && !hasBlockingErrors;

        let errorNe001 = false;
        Object.keys(validationResult.errors).forEach((key: string) => {
            validationResult.errors[key]?.forEach((e: any) => {
                if (e.error?.includes('NE-001')) {
                    errorNe001 = true;
                }
            });
        });

        const step = errorNe001 && canUpload ? 'Validate NE001' : 'CheckWsMessage';

        console.log('[UploadModal] validación completada', {
            step,
            canUpload,
            actividadesValidadas: validationResult.validatedActivities.length,
            erroresBloqueantes: blockingMessages.length,
            errores: blockingMessages,
        });

        setActivitiesToUpload(validationResult.validatedActivities);
        setUploadBlockingMessages(blockingMessages);
        setCanUploadActivities(canUpload);
        setUploadActivitiesStep(step);
        dispatch(gerenciaTecnicaSlice.actions.setUploadingStep(step));
        setUploadIsValidating(false);
    }, [
        uploadTaskWithVariables,
        uploadIsValidating,
        mainState,
        executedDate,
        activeFieldForActivities,
        cuadrillas,
        filterStates,
        originalFlow,
        numeroCuadrilla,
        groupAssigned,
        dispatch,
    ]);

    const onClickShowPdfList = async () => {
        setshowCartModalReport(true)
        setShowListOfActivities(true)
    }

    const onClickUploadActivities = () => {
        console.log('[UploadModal] click Cargar Actividades');
        setUploadSessionKey((key) => key + 1);
        setUploadActivitiesStep('CheckWsMessage');
        setActivitiesToUpload([]);
        setUploadBlockingMessages([]);
        setCanUploadActivities(false);
        setUploadIsValidating(true);
        setUploadTaskWithVariables(true);
        console.log('[UploadModal] modal de carga marcado como visible');
    }

    const closeUploadActivitiesModal = () => {
        console.log('[UploadModal] cerrando modal de carga');
        setUploadTaskWithVariables(false);
        setUploadIsValidating(false);
        dispatch(gerenciaTecnicaSlice.actions.setUploadingStep(''));
    }


    return (
        <>
            {showCartModalReport &&
                <div className='consolidate_files_container_modal_cart_report'>
                    <div className="consolidate_files_container_modal_cart_report_input_container" >
                        <div className="consolidate_files_container_header">
                            <div>Resumen Actividad Dinamometrica</div>
                            <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={() => setshowCartModalReport(false)} />
                        </div>
                        <div className="consolidate_files_container_modal_cart_report_button_container">
                            <ButtonBig text='Generar PDF' icon='/assets/icons/download-report.svg' onClick={() => onClickDownnloadPdf()} />
                            <ButtonBig text='Calcular Carta fondo' icon='/assets/icons/calculate.svg' onClick={() => { }} />
                        </div>
                        <div className="consolidate_files_container_modal_cart_list_scroll">
                            {showListOfActivities ? (
                                <>
                                    {mainState?.cardsWithActivities?.map((a, i) => (
                                        // <div ref={targetRef} key={i}>
                                        <ReportCard
                                            activeActivityWithCard={a}
                                            key={i}
                                            activityValidation={mainState?.taskValidations}
                                            activeFieldForActivities={activeFieldForActivities}
                                            targetRef={targetRef}
                                            setSizeToGeneratePdf={false}
                                        />
                                        // </div>
                                    ))}
                                </>
                            ) : (
                                <>
                                    {!reloadCartComponent && ((
                                        // <div ref={targetRef} className={`${setSizeToGeneratePdf ? "consolidate_files_container_letter_container" : ""}`}>
                                        // <div ref={targetRef}>
                                        <ReportCard
                                            activityValidation={mainState?.taskValidations}
                                            activeActivityWithCard={actveActivityWithCard}
                                            activeFieldForActivities={activeFieldForActivities}
                                            targetRef={targetRef}
                                            setSizeToGeneratePdf={setSizeToGeneratePdf}
                                        />
                                        // </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                </div>}
            {/* <div className='consolidate_files_container_external_container' > */}
            <div className='consolidate_files_container_info_container' >
                <div className="consolidate_files_container_header">
                    <div>Validar la Información antes de consolidar</div>
                    <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={onClose} />
                </div>
                <div className="consolidate_files_container_body">
                    <StatesTabs tabs={filterStates} activeState={activeState} setActiveState={setActiveState} />
                    {activeState === 'summary' &&
                        <GeneralTab
                            activeField={activeFieldForActivities}
                            setActiveField={handleFieldChange}
                            cuadrillas={cuadrillas}
                            onClickViewActivities={onClickVerActividades}
                            onChangeActivitiesField={onChangeActivitiesField}
                            executedDate={executedDate}
                            setExecutedDate={setExecutedDate}
                            numeroCuadrilla={numeroCuadrilla}
                            setNumeroCuadrilla={setNumeroCuadrilla}
                            groupAssigned={groupAssigned}
                        />}
                    {activeState === 'activities' &&
                        <ActivitiesList
                            ActiveCuadrilla={ActiveCuadrilla}
                            setActiveCuadrilla={setActiveCuadrilla}
                            activities={activities}
                            cuadrillas={cuadrillas}
                            onChangeActivitiesField={onChangeActivitiesField}
                            activeFieldForActivities={activeFieldForActivities}
                            errors={errors}
                        />}
                    {activeState === 'carts' &&
                        <CartsList
                            carts={carts}
                            activeFieldForActivities={activeFieldForActivities}
                            onClickViewCart={onClickViewCartFromCard}
                            onChangeActivitiesField={onChangeActivitiesField} />}
                    {tamFiles.length > 0 && tamTabMounted && (
                        <Box
                            sx={{
                                display: activeState === 'tam' ? 'flex' : 'none',
                                flex: 1,
                                minHeight: 0,
                                flexDirection: 'column',
                                overflow: 'hidden',
                                width: '100%',
                            }}
                        >
                            <TamConsolidateTab
                                tamFiles={tamFiles}
                                selectedFieldId={activeFieldForActivities}
                                executedDate={executedDate}
                                onExecutedDateChange={setExecutedDate}
                                activityWellHints={activityWellHints}
                                onReadyChange={handleTamReadyChange}
                            />
                        </Box>
                    )}
                    {activeState === 'errors' && <ErrorList errors={errors} />}
                    {activeState === 'files' &&
                        <ButtonsTab
                            onDownloadPdf={onClickShowPdfList}
                            onClickUploadActivities={onClickUploadActivities}
                            errors={errors}
                            tamReadyCount={tamReady.length}
                            tamFilesCount={tamFiles.length}
                        />
                    }

                </div>
                <div className="consolidate_files_container_button_container"></div>
            </div>
            {uploadTaskWithVariables && typeof document !== 'undefined' && createPortal(
                <div
                    className="consolidate_files_upload_portal_root"
                    role="dialog"
                    aria-modal="true"
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <UploadActivitiesModal
                        key={uploadSessionKey}
                        initialStep={uploadActivitiesStep}
                        executedDate={executedDate}
                        sortActivities={activitiesToUpload}
                        canUpload={canUploadActivities}
                        blockingMessages={uploadBlockingMessages}
                        isValidating={uploadIsValidating}
                        close={closeUploadActivitiesModal}
                        onActivitiesUploaded={handleUploadTam}
                        tamReadyCount={tamReady.length}
                    />
                </div>,
                document.body,
            )}
            {/* </div> */}
        </>
    )
}
